import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import AttachmentsProxy from '../../../api/attachments/AttachmentsProxy';

type AttachmentDownloadProp = {
  attachmentId: string
}

/**
 * Retrieves the attachment file from the API/DB and inserts it into an IFrame to display.
 *
 * @returns iframe component with the file data loaded.
 */
export const AttachmentDownload = (): React.JSX.Element => {
  const iframe = useRef<HTMLIFrameElement>(null);
  const { attachmentId } = useParams<AttachmentDownloadProp>();
  const [fileData, setFileData] = useState<any>();

  useEffect(() => {
    let objectUrl: string | null = null;

    AttachmentsProxy.download(attachmentId)
      .then((response) => {
        if (response.data) {
          objectUrl = URL.createObjectURL(response.data);
          setFileData(objectUrl);
        }
      }).catch((error) => {
        console.log(error);
      });

    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [attachmentId]);

  return (
    <iframe ref={iframe} title={attachmentId} src={fileData} className="pdf-frame" />
  );
};
